import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { Pencil } from 'lucide-react'; // se estiver usando lucide, senão troque por um ícone qualquer
import { API_URL } from '../../../environment';

interface Props {
  nome: string;
  fone: string;
  onNomeAtualizado: () => void;
}

const EditableNameCell: React.FC<Props> = ({ nome, fone, onNomeAtualizado }) => {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState(nome || "");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const salvarNome = async () => {
    const id_cliente = localStorage.getItem("id_cliente");
    try {
      await fetch(`${API_URL}/atualizarnome`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fone, nome: valor, id_cliente }),
      });
      setEditando(false);
      onNomeAtualizado();
    } catch (err) {
      console.error("Erro ao atualizar nome:", err);
    }
  };

  if (editando) {
    return (
      <input
        type="text"
        value={valor}
        onChange={(e) => setValor(e.target.value)}
        onBlur={salvarNome}
        onKeyDown={(e) => {
          if (e.key === "Enter") salvarNome();
        }}
        autoFocus
        style={{ width: "100%" }}
      />
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-between">
      <Link
        to={all_routes.chat}
        state={{ phone: fone.startsWith("55") ? fone : "55" + fone }}
        className="fw-medium fs-14 text-decoration-none text-dark"
      >
        {valor || "(sem nome)"}
      </Link>
      <button
        onClick={() => setEditando(true)}
        className="btn btn-sm btn-light border ms-2"
        title="Editar nome"
      >
        <Pencil size={14} />
      </button>
    </div>
  );
};

export default EditableNameCell;
